import type { Routes } from '@angular/router'
import { isAnonymous, isAuthenticated } from './shared/auth/auth.guard'
import { SimpleLayoutComponent } from './shared/layouts/simple-layout.component'
import { MainLayoutComponent } from './shared/layouts/main-layout.component'
import { MaintenanceComponent } from './maintenance/maintenance.component'
import { isPortalOpen } from './maintenance/maintenance.guard'

export const routes: Routes = [
  {
    path: 'login',
    component: SimpleLayoutComponent,
    canActivate: [isPortalOpen, isAnonymous],
    loadChildren: () => import('./login/login.routes').then((m) => m.routes),
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [isPortalOpen, isAuthenticated],
    children: [
      {
        path: '',
        redirectTo: 'portfolio',
        pathMatch: 'full',
      },
      {
        path: 'portfolio',
        loadChildren: () => import('./portfolio/portfolio.routes').then((m) => m.routes),
      },
      {
        path: 'companies',
        loadChildren: () => import('./company/company.routes').then((m) => m.routes),
      },
      {
        path: 'offer',
        loadChildren: () => import('./offer/offer.routes').then((m) => m.routes),
      },
    ],
  },
  {
    // eager because old chunks are gone during a deploy and the svg asset keeps its name in every build
    path: 'maintenance',
    component: MaintenanceComponent,
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
]
